export const INIT_ETAPE = 'INIT_ETAPE';
export const SET_ETAPE_ACTIVE = 'SET_ETAPE_ACTIVE';
export const INCREMENTER_ETAPE = 'INCREMENTER_ETAPE';
export const DECREMENTER_ETAPE = 'DECREMENTER_ETAPE';

export const setEtapeActive = (etape) => ({
    type: SET_ETAPE_ACTIVE,
    payload: etape,
});

export const etapeSuivante = () => (dispatch, getState) => {
    const { etapeActive } = getState().etapes.etapes;
    dispatch(setEtapeActive(etapeActive + 1));
};

export const etapePrecedente = () => (dispatch, getState) => {
    const { etapeActive } = getState().etapes.etapes;
    dispatch(setEtapeActive(etapeActive - 1 <= 1 ? 1 : etapeActive - 1));
};
